import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import type { HomeDetailsResponse, HcpRow, HcoRow } from '../types/api/generated';
import { HomeDetailsResponseSchema, HcpRowSchema, HcoRowSchema } from '../types/api/schemas';
import { validateResponse } from './validateResponse';

export const homeApi = createApi({
    reducerPath: 'homeApi',
    baseQuery,
    endpoints: (builder) => ({
        getHomeDetails: builder.mutation<HomeDetailsResponse, unknown>({
            query: (body) => ({ url: 'api/v2/home/details', method: 'POST', body }),
            transformResponse: validateResponse(HomeDetailsResponseSchema),
        }),
        getHomeHcp: builder.mutation<HcpRow[], unknown>({
            query: (body) => ({ url: 'api/v2/home/hcp', method: 'POST', body }),
            transformResponse: validateResponse(HcpRowSchema.array()),
        }),
        getHomeHco: builder.mutation<HcoRow[], unknown>({
            query: (body) => ({ url: 'api/v2/home/hco', method: 'POST', body }),
            transformResponse: validateResponse(HcoRowSchema.array()),
        }),
    }),
});

export const {
    useGetHomeDetailsMutation,
    useGetHomeHcpMutation,
    useGetHomeHcoMutation,
} = homeApi;
